function copyToClipboard(text) {
    // navigator api
    if(navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).then(() => {
            return true
        }, () => {
            return false
        });
    // compatibility mode    
    } else {

        let textArea = document.createElement("textarea");
        textArea.value = text;

        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        return documentCopy(textArea);
    }
}

function copy(textArea) {
    return new Promise((res, rej) => {
        document.execCommand('copy') ? 
            res(true) : rej(false);
        textArea.remove();
    });
}

async function documentCopy(textArea) {
    let result = await copy(textArea);
}

export {
    copyToClipboard,
};
